import type { WebhookBulkUpdateResponse } from 'api';
import { WebhookBulkUpdateResponseDataItemStatus } from 'api';

import { bulkAllFailedMessage, bulkPartialFailureMessage } from './utils';

export type BulkOutcome = { succeeded: number; failed: number };

type BulkOutcomeToastOptions = { allSuccess: string; verb: string };

type BulkOutcomeToastResult = {
  kind: 'success' | 'warning' | 'error';
  message: string;
};

export const summarizeBulkUpdate = (
  response: WebhookBulkUpdateResponse
): BulkOutcome => {
  const failed = response.data.filter(
    (item) => item.status === WebhookBulkUpdateResponseDataItemStatus.failed
  ).length;

  return { succeeded: response.data.length - failed, failed };
};

export const bulkOutcomeToast = (
  { succeeded, failed }: BulkOutcome,
  { allSuccess, verb }: BulkOutcomeToastOptions
): BulkOutcomeToastResult => {
  if (failed === 0) {
    return { kind: 'success', message: allSuccess };
  }

  if (succeeded === 0) {
    return { kind: 'error', message: bulkAllFailedMessage(verb) };
  }

  return {
    kind: 'warning',
    message: bulkPartialFailureMessage(succeeded, failed, verb)
  };
};
